import React from "react";
import { FDialog } from "ferrum-design-system";

export const MsSelectFeeTokenDlg = ({ show, onHide, networks }: any) => {
  return (
    <FDialog
      show={show}
      size={"large feetokenimg-m"}
      onHide={onHide}
      variant={"fee-token feetoken-m"}
      title="Fee Token"
    >
      <>
      <div className="feetokenbody">
        <div className="ms-select-token-fee-token-list">
          {networks && networks.length
            ? networks.map((item: any) => {
                return (
                  <div className="ms-select-token-fee-token">
                    <span>
                      <img src={item.logo} alt={item.name} />
                    </span>
                    <div className="ms-select-token-fee-info">
                      <p>
                        {item.name}{" "}
                        <span className="ms-select-token-fee-token-info">
                          (-25%)
                        </span>
                      </p>
                      <small>Balance: {item.price}</small>
                    </div>
                    <div className="ms-select-token-info-fee">
                      <p>Fees</p>
                      <small>{item.fee}</small>
                    </div>
                    <p className="ms-select-token-fee-token-price">
                      <p className="ms-select-token-fee-price-discount">
                        (~${item.price})
                      </p>
                      (~${item.price})
                    </p>
                  </div>
                );
              })
            : null}
        </div>
      </div>
      </>
    </FDialog>
  );
};
